import { sequenceTileInput } from '@utils/component-framework';

function updateInputsOnDrag(args, event) {
  if (event.active.id === event.over?.id) {
    return;
  }
  const sourceInputIndex = args.inputs.findIndex(it => it.id === event.active.id);
  const targetInputIndex = args.inputs.findIndex(it => it.id === event.over?.id);
  const sourceInput = args.inputs[sourceInputIndex];
  const targetInput = args.inputs[targetInputIndex];
  if (!sourceInput || !targetInput) {
    return;
  }
  args.update(args.taskEntryKey, prev => {
    const next = prev ?? {};

    //
    // STEP: Ensure all draggable inputs have been registered in our entry to
    // avoid shuffling this entry in the future.
    //
    for (let i = 0; i < args.inputs.length; i++) {
      const input = args.inputs[i];
      if (input && !input.options.fixed && !next[input.id]) {
        next[input.id] = {
          type: "sequence-tile",
          index: i
        };
      }
    }

    //
    // STEP: Shift inputs between source and target forwards or backwards,
    // depending on the direction the input is shifted.
    //
    const dir = sourceInputIndex < targetInputIndex ? "forwards" : "backwards";
    for (const entry of Object.values(next)) {
      const tileEntry = sequenceTileInput.entry.asTypeSafe(entry);
      if (!tileEntry) {
        continue;
      }
      if (dir === "forwards" && tileEntry.index > sourceInputIndex && tileEntry.index <= targetInputIndex) {
        const prevValidIndex = args.inputs.slice(0, tileEntry.index).findLastIndex(it => !it.options.fixed);
        tileEntry.index = prevValidIndex;
      }
      if (dir === "backwards" && tileEntry.index < sourceInputIndex && tileEntry.index >= targetInputIndex) {
        const nextValidIndex = args.inputs.slice(tileEntry.index + 1).findIndex(it => !it.options.fixed) + 1;
        tileEntry.index = tileEntry.index + nextValidIndex;
      }
    }

    //
    // STEP: Finally position our source at its new position.
    //
    next[sourceInput.id] = {
      type: "sequence-tile",
      index: targetInputIndex
    };

    //
    // STEP: Ensure that entries are updated synchronously to avoid flickers
    // in the UI.
    //
    args.updateUI(Object.entries(next).filter(it => !!sequenceTileInput.entry.asTypeSafe(it[1])).map(([key, value]) => ({
      nodeId: key,
      ...value
    })));
    return next;
  });
}

export { updateInputsOnDrag };
//# sourceMappingURL=util.update-inputs-on-drag-over.js.map
